import UpperFunnelChiclet from 'components/Catalog/UpperFunnel/UpperFunnelChiclet/UpperFunnelChiclet';

export default UpperFunnelChiclet;
